module.exports = __webpack_public_path__ + "static/a-thousand-splendid-suns-bbbbcbf4d26f97716e65e7755379799d.jpg";